<template>
    <div>
        <app-tabela
            idTabela="tblCertidoesLog"
            :itens="logs"
            :campos="campos"
            :itensPorPagina="itensPorPagina"
            :mostrarFiltro="false"
        >
            <template slot="statusCertidao" slot-scope="data">
                <app-status
                    :status="
                        data.statusCertidao
                            ? data.statusCertidao.toUpperCase()
                            : ''
                    "
                ></app-status>
            </template>
            <template slot="statusRm" slot-scope="data">
                <app-status
                    :status="data.statusRm ? data.statusRm.toUpperCase() : ''"
                ></app-status>
            </template>
            <template slot="acoes" slot-scope="data">
                <btn-mostrar-conteudo
                    btnTitulo="Retorno da API"
                    icon="fa-code"
                    titulo="Retorno da API"
                    :conteudo="data.retornoCertidao"
                    tipo="J"
                    v-if="mostrarRetornoApi"
                ></btn-mostrar-conteudo>
                <btn-mostrar-conteudo
                    btnTitulo="Retorno do RM"
                    icon="fa-file-text-o"
                    titulo="Retorno do RM"
                    :conteudo="data.retornoRm"
                    tipo="T"
                    v-if="mostrarRetornoRm"
                ></btn-mostrar-conteudo>
                <btn-mostrar-conteudo
                    btnTitulo="XML RM"
                    icon="fa-file-code-o"
                    titulo="XML RM"
                    :conteudo="data.xml"
                    tipo="X"
                    v-if="mostrarXml"
                ></btn-mostrar-conteudo>
            </template>
        </app-tabela>
    </div>
</template>

<script>
import CertidoesServicos from './../rm/CertidoesServicos'
import BtnMostrarConteudo from './BtnMostrarConteudo'

export default {
    props: {
        logs: {
            type: Array,
            default: () => []
        }
    },
    components: { BtnMostrarConteudo },
    data() {
        return {
            campos: [
                {
                    key: 'dataAtualizacao',
                    label: 'Data da Atualização',
                    tdClass: 'text-center',
                    type: 'datetime'
                },
                {
                    key: 'statusCertidao',
                    label: 'Status Certidão',
                    tdClass: 'text-center'
                },
                {
                    key: 'statusRm',
                    label: 'Status RM',
                    tdClass: 'text-center'
                },
                {
                    key: 'acoes',
                    label: 'Ações'
                }
            ],
            itensPorPagina: 5
        }
    },
    methods: {},

    created() {},

    computed: {
        mostrarRetornoApi() {
            return this.$temAcessoView('CERT-04')
        },

        mostrarRetornoRm() {
            return this.$temAcessoView('CERT-05')
        },

        mostrarXml() {
            return this.$temAcessoView('CERT-06')
        }
    },

    watch: {}
}
</script>

